<!-- THIS COMPONENT IS NOT USED ANYWHERE -->
<template>
  <div>
    <canvas
      :id="canvasId"
      class="canvas-style"
      @mousedown="onMouseDown"
      @mouseup="onMouseUp"
      @mousemove="onMouseMove"
    />
  </div>
</template>

<script>
// TODO: move all of this logic to master
// packages
const paper = require('paper')
const fs = require('browserify-fs')
//let importData = require("./output.json");

export default {
  name: 'Canvas',
  props: ['canvasId'],
  data: () => ({
    path: null,
    tool: null,
    scope: null,
    segment: null,
    movePath: false,
    raster: null,
    lastSelected: null,
    dragging: false,
    values: {
      paths: 1,
      minPoints: 4,
      maxPoints: 4,
      minRadius: 40,
      maxRadius: 40
    },
    hitOptions: {
      segments: true,
      stroke: true,
      fill: true,
      tolerance: 5
    }
  }),
  mounted() {
    const self = this
    window.addEventListener('keypress', function(e) {
      // use self instead of this in here
      console.log(String.fromCharCode(e.keyCode))
      self.onKeyUp(e)
    })
    // window.addEventListener("mousemove", function(e) {
    //   // use self instead of this in here
    //   console.log(String.fromCharCode(e.keyCode));
    //   self.onMouseDrag(e);
    // });
    this.scope = new paper.PaperScope()
    this.scope.setup(this.canvasId)
    this.tool = this.createTool(self.scope)
    //this.path = new paper.Path();
    // this.raster = new paper.Raster(
    //  "https://3d.belgradewaterfront.com/common/images/complex/image-1588754388-2259.jpg"
    //);
    //this.scope.project.activeLayer.addChild(this.raster);
    // Move the raster to the center of the view
    //this.raster.position = this.scope.view.center;
    //Scale the raster by 50%
    //this.raster.scale(1);
    var circle = new paper.Path.Circle({
      center: [888, 888],
      radius: 100,
      fillColor: 'red'
    })
    self.path = self.pathCreate(self.scope)
    this.createPaths(this.scope)
    //this.importProjectFromJson();
    //Rotate the raster by 45 degrees:
    //raster.rotate();

    // $("#myCanvas").on("mousewheel", function(event) {
    // 	if (event.shiftKey) {
    // 		view.center = changeCenter(
    // 			view.center,
    // 			event.deltaX,
    // 			event.deltaY,
    // 			event.deltaFactor
    // 		);
    // 		event.preventDefault();
    // 	} else if (event.altKey) {
    // 		view.zoom = changeZoom(view.zoom, event.deltaY);
    // 		event.preventDefault();
    // 	}
    // });
  },
  created() {},
  destroyed() {
    // TO DO: find a way to remove event listener after leaving editor
    window.removeEventListener('keypress', function(e) {
      // use self instead of this in here
      console.log(String.fromCharCode(e.keyCode))
      self.onKeyUp(e)
    })
  },
  methods: {
    reset() {
      this.scope.project.activeLayer.removeChildren()
    },
    // onMouseDown(event) {
    // 	//console.log('event',event)
    // 	segment = path = null;
    // 	var hitResult = project.hitTest(event.point, hitOptions);
    // 	if (!hitResult) return;

    // 	if (event.modifiers.shift) {
    // 		if (hitResult.type == "segment") {
    // 			hitResult.segment.remove();
    // 		}
    // 		return;
    // 	}

    // 	if (hitResult) {
    // 		path = hitResult.item;
    // 		if (hitResult.type == "segment") {
    // 			segment = hitResult.segment;
    // 		} else if (hitResult.type == "stroke") {
    // 			var location = hitResult.location;
    // 			segment = path.insert(location.index + 1, event.point);
    // 			//path.smooth();
    // 		}
    // 	}
    // 	movePath = hitResult.type == "fill";
    // 	if (movePath) project.activeLayer.addChild(hitResult.item);

    // 	console.log(JSON.stringify(path));
    // },

    // onMouseMove(event) {
    // 	project.activeLayer.selected = false;
    // 	if (event.item) event.item.selected = true;
    // },

    // onMouseDrag(event) {
    // 	if (segment) {
    // 		segment.point += event.delta;
    // 		//path.smooth();
    // 	} else if (path) {
    // 		path.position += event.delta;
    // 	}
    // },

    // onKeyUp(event) {
    // 	// When a key is released, set the content of the text item:
    // 	//text.content = 'The ' + event.key + ' key was released!';
    // 	if (event.key === "c") {
    // 		createPaths();
    // 	}

    // 	if (event.key === "e") {
    // 		raster.scale(1);

    // 		raster.visible = false;
    // 		var fileName = "custom.json";
    // 		console.log(path);
    // 		var url =
    // 			"data:image/svg+xml;utf8," +
    // 			encodeURIComponent(
    // 				project.activeLayer.lastChild.exportJSON({ asString: true })
    // 			);
    // 		var link = document.createElement("a");
    // 		link.download = fileName;
    // 		link.href = url;
    // 		link.click();
    // 		raster.visible = true;
    // 	}
    // },

    pathCreate(scope) {
      scope.activate()
      return new paper.Path({
        strokeColor: '#000000',
        strokeJoin: 'round',
        strokeWidth: 1.5
      })
    },
    createTool(scope) {
      scope.activate()
      return new paper.Tool()
    },
    onMouseDown(event) {
      // in order to access functions in nested tool
      let self = this

      // create drawing tool
      //this.tool = this.createTool(this.scope);
      // this.tool.onMouseDown = (event) => {
      // 	// init path
      // 	self.path = self.pathCreate(self.scope);
      // 	// add point to path
      // 	self.path.add(event.point);
      // };
      // this.tool.onMouseDrag = (event) => {
      // 	self.path.add(event);
      // };
      // this.tool.onMouseUp = (event) => {
      // 	// line completed
      // 	self.path.add(event.point);
      // };
      this.tool.onMouseDown = function(event) {
        self.dragging = true

        // remove selection
        if (self.lastSelected && self.lastSelected !== event.item) {
          self.lastSelected.selected = false
        }
        // select
        if (event.item) {
          event.item.selected = true
          self.lastSelected = event.item
        }

        self.segment = self.path = null
        var hitResult = self.scope.project.hitTest(event.point, self.hitOptions)
        if (!hitResult) return
        if (event.shiftKey) {
          if (hitResult.type == 'segment') {
            hitResult.segment.remove()
          }
          return
        }

        if (hitResult) {
          self.path = hitResult.item
          if (hitResult.type == 'segment') {
            self.segment = hitResult.segment
          } else if (hitResult.type == 'stroke') {
            var location = hitResult.location
            self.segment = self.path.insert(location.index + 1, event.point)
            //self.path.smooth();
          }
        }
        if (hitResult.type == 'fill') {
          self.movePath = true
        } else {
          self.movePath = false
        }
        if (self.movePath)
          self.scope.project.activeLayer.addChild(hitResult.item)
      }
    },

    onMouseUp(event) {
      var self = this
      this.tool.onMouseUp = function(event) {
        self.dragging = false
        // remove selection
        // if (self.lastSelected) {
        //   console.log("last: ", self.lastSelected);
        //   self.lastSelected.selected = false;
        // }
      }
    },
    onMouseMove(event) {
      let self = this

      this.tool.onMouseMove = function(event) {
        //self.scope.project.activeLayer.selected = false;
        //if (event.item) event.item.selected = true;
        if (self.dragging) {
          self.doDrag(event)
        }
      }
    },

    doDrag(event) {
      let self = this
      if (self.segment) {
        //self.segment.point += event.delta;
        self.segment.point = new paper.Point(
          self.segment.point.x + event.delta.x,
          self.segment.point.y + event.delta.y
        )
        //path.smooth();
      } else if (self.path) {
        //self.path.position += event.delta;
        self.path.position = new paper.Point(
          self.path.position.x + event.delta.x,
          self.path.position.y + event.delta.y
        )
      }
    },

    onKeyUp(event) {
      let self = this

      this.tool.onKeyUp = function(event) {
        // When a key is released, set the content of the text item:
        //text.content = 'The ' + event.key + ' key was released!';
        if (event.key === 'c') {
          self.createPaths(self.scope)
        }

        if (event.key === 'd' && self.lastSelected) {
          self.lastSelected.remove()
        }
        if (event.key === 'e') {
          // self.raster.scale(1);
          // self.raster.visible = false;
          // var fileName = "custom.json";
          // console.log(path);
          // var url =
          //   "data:image/svg+xml;utf8," +
          //   encodeURIComponent(
          //     project.activeLayer.lastChild.exportJSON({ asString: true })
          //   );
          // var link = document.createElement("a");
          // link.download = fileName;
          // link.href = url;
          // link.click();
          // self.raster.visible = true;
        }
      }
    },

    createPaths(scope) {
      var radiusDelta = this.values.maxRadius - this.values.minRadius
      var pointsDelta = this.values.maxPoints - this.values.minPoints
      for (var i = 0; i < this.values.paths; i++) {
        var radius = this.values.minRadius + Math.random() * radiusDelta
        var points =
          this.values.minPoints + Math.floor(Math.random() * pointsDelta)
        var x = this.scope.view.size._width * paper.Point.random().x
        console.log('X: ', this.scope.view.size._width, paper.Point.random().x)

        var y = this.scope.view.size._height * paper.Point.random().y

        console.log('Y: ', this.scope.view.size._height, paper.Point.random().y)

        var center = new paper.Point(x, y)
        //center = paper.Point()(this.scope.view.size * paper.Point.random());
        this.path = this.createBlob(center, radius, points, scope)
        var lightness = (Math.random() - 0.5) * 0.4 + 0.4
        var hue = Math.random() * 360
        this.path.fillColor = {
          hue: hue,
          saturation: 1,
          lightness: lightness,
          alpha: 0.5
        }
        this.path.strokeColor = 'black'
      }
    },

    createBlob(center, maxRadius, points, scope) {
      scope.activate()
      var path = new paper.Path()
      path.closed = true
      for (var i = 0; i < points; i++) {
        var delta = new paper.Point({
          length: maxRadius * 0.5 + Math.random() * maxRadius * 0.5,
          angle: (360 / points) * i
        })
        path.add(new paper.Point(center.x + delta.x, center.y + delta.y))
      }
      //path.smooth();
      //path.flatten(4);
      path.data = Object.assign(path.data, { apartmentId: 1 })
      return path
    },

    changeZoom(oldZoom, delta) {
      var factor = 1.05
      if (delta < 0) {
        return oldZoom * factor
      }

      if (delta > 0) {
        return oldZoom / factor
      }
    },

    changeCenter(oldCenter, deltaX, deltaY, factor) {
      var offset = new paper.Point(deltaX, -deltaY)
      offset = offset.multiply(factor)
      oldCenter.add(offset)
    },

    exportProjectToJson(event) {
      this.scope.project.activeLayer.selected = false
      //this.scope.project.raster.visible = false;
      let projectData = this.scope.project.exportJSON()
      // console.log("EXPORTING>..");
      // fs.writeFile(
      // 	"output.json",
      // 	JSON.stringify(data, null, 4),
      // 	"utf8",
      // 	function(err) {
      // 		if (err) throw err;
      // 	}
      // );
      fs.mkdir('/saved', function() {
        fs.writeFile(
          '/saved/output.json',
          JSON.stringify(projectData, null, 4),
          function() {
            fs.readFile('/saved/output.json', 'utf-8', function(err, data) {
              //this.scope.project.raster.visible = true;
            })
          }
        )
      })
    },

    importProjectFromJson() {
      let self = this
      fs.readFile('/saved/output.json', 'utf-8', function(err, data) {
        self.scope.project.importJSON(JSON.parse(data))
      })
    }
  }
}
</script>

<style scoped>
.canvas-style {
  background: black;
  width: 100%;
  height: 100%;
}
</style>
